import type { CustomerStat } from '@/lib/analytics-api';

interface Props {
  customers: CustomerStat[];
  onSelect: (customerId: string) => void;
}

function fmt(n: number): string {
  return new Intl.NumberFormat('de-DE').format(n);
}

export default function CustomerBreakdown({ customers, onSelect }: Props) {
  return (
    <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
      <div className="px-4 py-3 border-b border-gray-100">
        <h2 className="text-sm font-semibold text-gray-900">Kunden im Vergleich</h2>
        <p className="text-xs text-gray-500 mt-0.5">Zeile anklicken für die Detailansicht des Kunden.</p>
      </div>
      {customers.length === 0 ? (
        <div className="px-4 py-8 text-center text-sm text-gray-400">Keine Tracking-Daten im Zeitraum.</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead className="bg-gray-50">
              <tr className="text-left text-xs text-gray-400 uppercase tracking-wider">
                <th className="px-4 py-2 font-medium">Kunde</th>
                <th className="px-4 py-2 font-medium text-right">Besucher</th>
                <th className="px-4 py-2 font-medium text-right">Aufrufe</th>
                <th
                  className="px-4 py-2 font-medium text-right"
                  title={'Alle Kontaktaufnahmen: Formular-Anfragen plus Klicks auf Telefonnummer oder E-Mail. Aufschlüsselung in der Zelle.'}
                >
                  Kontaktanfragen
                </th>
                <th className="px-4 py-2 font-medium text-right">Konversion</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {customers.map((c) => (
                <tr
                  key={c.customer_id}
                  onClick={() => onSelect(c.customer_id)}
                  className="hover:bg-primary-50 cursor-pointer"
                >
                  <td className="px-4 py-2 font-medium text-gray-900">{c.name}</td>
                  <td className="px-4 py-2 text-right tabular-nums">{fmt(c.visitors)}</td>
                  <td className="px-4 py-2 text-right tabular-nums text-gray-500">{fmt(c.pageviews)}</td>
                  <td className="px-4 py-2 text-right tabular-nums">
                    {fmt(c.kontakte ?? c.leads)}
                    {(c.contact_clicks ?? 0) > 0 && (
                      <span className="block text-[11px] font-normal text-gray-400">
                        {fmt(c.leads)} Formular · {fmt(c.contact_clicks ?? 0)} Tel./Mail
                      </span>
                    )}
                  </td>
                  <td className="px-4 py-2 text-right tabular-nums text-gray-500">
                    {(c.conversion_rate * 100).toFixed(1)} %
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
